import { render, staticRenderFns } from "./FeatureTeaser.vue?vue&type=template&id=3d8391c6&scoped=true&"
var script = {}
import style0 from "./FeatureTeaser.vue?vue&type=style&index=0&id=3d8391c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8391c6",
  null
  
)

export default component.exports